<!--CFS > Scan Pack-->
<template>
  <div>
    <a-drawer :title="$t('pubGicSet.ScanPack')+ '('+ orderNo + ')'" @close="onClose" :visible="visible" width="95%"
      :maskClosable="false">
      <a-row type="flex" justify="start" style="margin: 10px 0 0 0">
        <a-col>
          <div class="scanpackHeader">
            <div class="scanpackTitle" style="text-align: right; width: 100px">{{ $t('cfs.orderNo') }}:</div>
            <a-input style="width: 150px" ref="relIdRef" :placeholder="$t('publicLang.PleaseEnter')"
              v-model="orderNoVal" size="small" @pressEnter="searchOrderNo" />
          </div>
        </a-col>
        <a-col>
          <a-row type="flex" justify="start">
            <div style="margin-left: 4px;">
              <a-button v-if="showSearch" size="small" type="primary" @click="searchOrderNo">
                {{ $t('generic.Searchable') }}
              </a-button>
              <a-button v-else size="small" type="primary" @click="reset">
                {{ $t('job.Reset') }}
              </a-button>
            </div>
          </a-row>
        </a-col>
      </a-row>
      <a-divider style="margin: 10px 0"></a-divider>

      <a-row>
        <vxe-table border :data.sync="tableList" ref="skuTable" class="mytable-style" :cell-class-name="cellClassName"
          max-height="280" show-footer resizable :footer-method="footerMethod"
          :footer-cell-class-name="footerCellClassName" size="mini" :row-style="rowStyle">
          <template v-slot:empty>
            <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
          </template>
          <vxe-table-column type="checkbox" width="50"></vxe-table-column>
          <vxe-table-column field="parcelNo" :title="$t('cfs.parcelNo')" show-header-overflow="ellipsis"
            show-overflow="ellipsis"></vxe-table-column>
          <vxe-table-column field="trackingNo" :title="$t('cfs.trackingNo')" show-header-overflow="ellipsis"
            show-overflow="ellipsis"></vxe-table-column>
          <vxe-table-column field="invoiceFlag" :title="$t('cfs.invoiceFlag')" show-header-overflow="ellipsis"
            show-overflow="ellipsis"></vxe-table-column>
          <vxe-table-column field="unScanQty" :title="$t('cfs.unScanQty')" show-header-overflow="ellipsis"
            show-overflow="ellipsis"></vxe-table-column>
          <vxe-table-column field="scannedQty" :title="$t('cfs.scannedQty')" show-header-overflow="ellipsis"
            show-overflow="ellipsis"></vxe-table-column>
        </vxe-table>
      </a-row>

      <a-row class="mt">
        <!--左侧-->
        <a-col :span="12" style="marginTop:6px">
          <a-row>
            <a-form :form="form" class="ant-advanced-search-form">
              <a-row :gutter="24">
                <a-col :span="8" offset="1">
                  <a-form-item :label="$t('cfs.parcelNo')">
                    <a-input ref="parcelNoRef" style="width: 100%;" v-model="parcelNo"
                      :placeholder="$t('publicLang.PleaseEnter')" size="small" @pressEnter="parcelNoEnterEvt" />
                  </a-form-item>
                </a-col>
                <a-col :span="5">
                  <a-form-item :label="$t('pubGicSet.RemoveScanItem')">
                    <a-checkbox :checked="DeleteChecked" @change="DeleteChangeEvnt"></a-checkbox>
                  </a-form-item>
                </a-col>
                <a-col :span="8" v-if="showPrintLabel">
                  <a-form-item :label="$t('cfs.noOfDestinationLabelRequired')">
                    <a-input-number v-model="noOfDestinationLabel" size="small" :min="1" :disabled="scanLoad"
                      @pressEnter="parcelNoEnterEvt" />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="7" offset="2">
                  <a-form-item :label="$t('pubGicSet.Qty')">
                    <a-input :disabled="lockChecked" style="width: 100%;" v-model="OtySaoNum"
                      :placeholder="$t('publicLang.PleaseEnter')" size="small" ref="SacnPackSaomaQtyNum"
                      @pressEnter="parcelNoEnterEvt" @change="parcelNoEnterEvt" />
                  </a-form-item>
                </a-col>
                <a-col :span="5">
                  <a-form-item :label="$t('pubGicSet.LockScanQty')">
                    <a-checkbox :checked="lockChecked" @change="lockChangeEvnt"></a-checkbox>
                  </a-form-item>
                </a-col>
                <a-col>
                  <a-button v-show=" this.unScanQty == 0 && this.showPrintLabel" size="small" type="primary"
                    @click="showUrl">
                    {{ $t('cfs.printLabel') }}
                  </a-button>
                  <a-button style="margin-left: 10px;" v-show="this.unScanQty == 0 && this.showDhlInvoiceUrl.length > 0" size="small" type="primary" @click="showDhlInvoice">{{ $t('cfs.printDhlInvoice') }}</a-button>
                </a-col>
              </a-row>
            </a-form>
          </a-row>
          <a-row type="flex" justify="start" style="margin: 10px 0">
            <a-col style="margin-left: 30px;">
              <p class="scanCodeTile">{{ $t('cfs.scannedQty') }}</p>
              <div class="radius" style="background: #009900;">
                <i :style="{fontSize:setFontSize(this.scannedQty)}">{{ scannedQty }}</i>
              </div>
            </a-col>
            <a-col style="margin-left: 30px;">
              <p class="scanCodeTile">{{ $t('cfs.unScanQty') }}</p>
              <div class="radius" style="background: #f36;">
                <i :style="{fontSize:setFontSize(this.unScanQty)}">{{ unScanQty }}</i>
              </div>
            </a-col>
          </a-row>
        </a-col>

        <!--右侧-->
        <a-col :span="12" style="float: right">
          <a-row>
            <a-form-item :label="$t('cfs.parcelNoTrackingNo')">
              <a-input :disabled="true" style="width: 300px;" v-model="trackingNumber" size="small" />
            </a-form-item>
          </a-row>
          <a-row>
            <a-form-item :label="$t('cfs.destinationCountry')">
              <a-col v-if="showCounrty" class="existDataStyle" style="background-color: #00CCFF;">
                <p>{{destinationCountry}}</p>
              </a-col>
              <a-col v-else class="noDataStyle" />
            </a-form-item>
          </a-row>
          <a-row>
            <a-form-item :label="$t('cfs.courier')">
              <a-col v-if="showCourier" class="existDataStyle" style="background-color: #6666FF;">
                <p>{{courier}}</p>
              </a-col>
              <a-col v-else class="noDataStyle" />
            </a-form-item>
          </a-row>
        </a-col>
      </a-row>
    </a-drawer>

    <audio v-if="showSound" controls="controls" autoplay="autoplay" id="loadSound" hidden>
      <source src="../../../assets/mm.mp3" type="audio/mpeg" />
    </audio>

  </div>
</template>
<script>
  import ajax from "../../../api/ajax";
  import api from "../../../api/url";
  import axios from "axios";
  import {
    mapState
  } from "vuex";
  export default {
    data() {
      return {
        cartonNoDis: false, // sscc 是否可输入
        btnFunArr: [],
        scanFieldTitle: '',
        scanpackDetailTable: [],
        scanpackTabsTarget: '2',
        scanpackDetailAllocatedQty: 0,
        scanpackDetailPackedQty: 0,
        scanpackDetailPercentage: 0,
        scanpackDetailNocarton: 0,
        closeAndNewDisab: true,
        newDisab: false,
        closeDisab: true,
        removeDisab: true,
        appendDisab: true,
        errMsg: "Please new one carton first",
        labelCol: {
          xs: {
            span: 24
          },
          sm: {
            span: 5
          },
        },
        wrapperCol: {
          xs: {
            span: 24
          },
          sm: {
            span: 12
          },
        },
        cartonSearchVal: "",
        SkuExistVis: false,
        addCortonVisible: false, // New 弹窗
        editForm: this.$form.createForm(this),
        addform: this.$form.createForm(this),
        form: this.$form.createForm(this),
        visible: false,
        copslaShow: true,
        partTable: [], // 父表数据
        cartonTable: [],
        newEditCartData: {},
        tableList: [], //列表数据集合
        editSpin: false, // 编辑加载提示
        selectRow: "", // 父表当前选中行用来样式
        carTonQty: 0, //  carton 显示的number
        carTonOfSku: 0, //  carton 显示的number

        //      sku 扫码后换算后的值
        skuPackedQty: 0, // sku 显示num
        skuUnpackQty: 0, // sku 显示num
        Percentage: 0, // sku 显示num
        trackingNumber: "",
        parcelNo: "", // 扫码需要输入的值
        noOfDestinationLabel: 1,
        parcelNoNow: "", //存放点击Print Label按钮需要更新数据的ParcelNo
        OtySaoNum: 1, // oty 所需要操作数量
        lockChecked: true,
        DeleteChecked: false,
        SkuTableOther: {},
        newType: "",
        orderNoVal: "",
        showSearch: true, //是显示查询还是显示重置按钮
        orderNo: "",
        tableRelId: '',
        cartonTypeSelectData: [],
        newCartonJson: {},
        scanpackSearchType: '', // so 还是ware 进来
        WareheaderSearchVal: '',
        PrintSsccVal: '',
        scanPackDtoList: [], // 记录扫货次数
        cartonTableXt: [],
        waveUid: null,
        soUid: null,
        trackingNoMap: {},
        destinationCountry: "",
        courier: "",
        showCounrty: false,
        showCourier: false,
        scannedQty: 0,
        unScanQty: 0,
        showPrintLabel: false,
        printLabelUrl: "",
        showDhlInvoiceUrl:'',
        showSound: false, //显示声音控件
        scanLoad: false, //是否可以修改"No. of Destination Label required"的值
      }
    },
    computed: {
      
      setFontSize() {
        return function (val) {
          let size = 100;
          val = val + '';
          if (val.length == 1) {
            size = 260;
          } else if (val.length == 2) {
            size = 220;
          } else if (val.length == 3) {
            size = 180;
          } else if (val.length == 4) {
            size = 140;
          }
          return size + 'px';
        }
      }
    },
    watch: {
      SkuExistVis(val) {
        if (!val) {
          let audio = document.getElementById("loadSound");
          audio.pause();
        }
      }
    },
    methods: {
      //      footer 样式
      footerCellClassName({
        $rowIndex,
        column,
        columnIndex
      }) {
        return 'footerBackColor'
      },
      footerMethod({
        columns,
        data
      }) {
        let that = this;
        return [
          columns.map((column, columnIndex) => {
            if (["unScanQty", "scannedQty"].includes(column.property)) {
              return that.sumPubFn(column.property);
            }
          })
        ];
      },
      sumPubFn(val) {
        let arr = this.tableList;
        let sum = 0;
        for (let index in arr) {
          sum += parseInt(arr[index][val]);
        }
        return sum;
      },
      //            关闭弹窗
      onClose() {
        this.showSearch = true;
        this.visible = false;
        this.clearTopData();
        this.clearBottomData();
      },
      reset() { //重置
        this.clearTopData();
        this.clearBottomData();
        this.showSearch = true; //显示查询按钮
      },
      //            打开弹窗
      show(id, type) {
        this.visible = true
      },
      clearTopData() {
        this.tableList = [];
        this.orderNo = "";
        this.orderNoVal = "";
        this.scannedQty = 0;
        this.unScanQty = 0;
        this.showPrintLabel = false;
      },
      clearBottomData() { //清空底部数据
        this.parcelNo = "";
        this.DeleteChecked = false;
        this.noOfDestinationLabel = 1;
        this.OtySaoNum = 1;
        this.lockChecked = true;
        this.trackingNumber = "";
        this.showCounrty = false;
        this.destinationCountry = "";
        this.showCourier = false;
        this.courier = "";
        this.showPrintLabel = false;
        this.showDhlInvoiceUrl = '';
      },
      searchOrderNo() {
        this.clearBottomData();
        this.orderNoSearch();
      },
      orderNoSearch() {
        if ((this.orderNoVal == null || this.orderNoVal == '') && (this.orderNoVal == null && this.orderNoVal == '')) {
          this.$customMessage.warning(this.$t('cfs.orderNo') + " " + this.$t('job.notNull'), 2);
          return;
        }
        let params = new FormData();
        params.append("orderNo", this.orderNoVal);
        params.append("parcelNo", this.parcelNo);
        ajax.post(api.CFSSCANPACKSEARCHORDERNO, params).then(res => {
          if (res.code == 200) {
            if (res.data != undefined && res.data != null) {
              this.orderNo = this.orderNoVal;
              this.tableList = res.data;
              this.scannedQty = 0;
              this.unScanQty = 0;
              for (let index in res.data) { //统计已扫描,未扫描数量
                this.scannedQty += parseInt(res.data[index]['scannedQty']);
                this.unScanQty += parseInt(res.data[index]['unScanQty']);
              }
              this.showPrintLabel = res.showPrintLabel;
              this.printLabelUrl = res.printLabelUrl;
              if(res.showDhlInvoiceUrl != null){
                this.showDhlInvoiceUrl = res.showDhlInvoiceUrl;
              }
              this.destinationCountry = res.destinationCountry;
              if (this.destinationCountry != null && this.destinationCountry.length > 0) {
                this.showCounrty = true;
              }
              this.courier = res.courier;
              if (this.courier != null && this.courier.length > 0) {
                this.showCourier = true;
              }
              this.showSearch = false; //显示重置按钮
              this.scanLoad = res.scanLoad;
              if (res.orderNo != undefined && res.orderNo != null) {
                this.orderNo = res.orderNo;
                if (this.orderNoVal == null || this.orderNoVal == '') {
                  this.orderNoVal = res.orderNo;
                }
              }
            }
          } else {
            this.$customMessage.warning(res.msg);
          }
        })
      },
      //Enter事件
      parcelNoEnterEvt() {

        if (this.parcelNo.length == 0) {
          this.$customMessage.warning(this.$t('cfs.parcelNo') + " " + this.$t('job.notNull'), 3); //不能为空
          return;
        }

        if (this.orderNo == null || this.orderNo == '') {
          //  this.scanParcelNo();
          this.orderNoSearch();
          this.scanParcelNo();
          return;
        }


        if (this.tableList.length == 0) { //校验是否有扫描OrderNo数据
          this.$customMessage.warning(this.$t('pubGicSet.NoRecordfound'), 3);
          return;
        }

        if (!this.lockChecked) { //如果没有选中Lock Scan Qty,则光标跳转到Qty输入框
          this.$refs.SacnPackSaomaQtyNum.focus()
        } else {
          this.scanParcelNo();
        }
      },
      scanParcelNo() {
        let params = new FormData();
        params.append("orderNo", this.orderNo);
        params.append("parcelNo", this.parcelNo);
        params.append("qty", this.OtySaoNum);
        params.append("removeScanItem", this.DeleteChecked);
        ajax.post(api.CFSSCANPARCELNO, params).then(res => {
          if (res.code == 200) {
            this.orderNo = res.data.orderNo;
            if (this.orderNoVal == null || this.orderNoVal == '') {
              this.orderNoVal = res.data.orderNo;
            }
            this.orderNoSearch();
            this.trackingNumber = res.data.trackingNumber;
            this.destinationCountry = res.data.destinationCountry;
            if (this.destinationCountry != null && this.destinationCountry.length > 0) {
              this.showCounrty = true;
            }
            this.courier = res.data.courier;
            if (this.courier != null && this.courier.length > 0) {
              this.showCourier = true;
            }
            this.showPrintLabel = res.data.showPrintLabel;
            this.printLabelUrl = res.data.printLabelUrl;
            if (this.DeleteChecked) { //如果是删除返回的信息
              this.trackingNumber = "";
              this.showCounrty = false;
              this.showCourier = false;
            }
            this.DeleteChecked = false;
            this.parcelNoNow = this.parcelNo;
            if(res.data.showDhlInvoiceUrl != null){
              this.showDhlInvoiceUrl = res.data.showDhlInvoiceUrl;
            }
          } else {
            this.$customMessage.warning(res.msg);
            this.audioPubFun(); //播放声音
          }
          this.parcelNo = "";
        })
      },
      //            播放提示声
      audioPubFun() {
        this.showSound = true;
        let audio = document.getElementById("loadSound");
        if (audio !== null) {
          if (audio.paused) {
            audio.play();
          } else {
            audio.pause();
          }
        }
      },
      //            lock扫码数量事件
      lockChangeEvnt(e) {
        this.lockChecked = !this.lockChecked;
        if (!this.lockChecked) {
          this.$refs.SacnPackSaomaQtyNum.focus()
          this.OtySaoNum = null
        } else {
          this.OtySaoNum = 1
        }
      },
      pubPdfUploadOk(data){
        this.isBtnajax = false
        this.$store.commit("updataLoading", { pbLoading: false });
        let blob = new Blob([data.data], {type: "application/pdf;charset=utf-8"});
        let url = window.URL.createObjectURL(blob);
        window.open(url);
      },
      // paf接口返回值处理
      pubPdfMsgfn(res, oriPriLabelUrl){
        let data = res.data;
        let fileReader = new FileReader();
        let that = this
        fileReader.onload = function() {
          try {
            let jsonData = JSON.parse(this.result);
            if (jsonData.code == 200) {
              if (jsonData.printUrl != null && jsonData.printUrl != '') {
                window.open(jsonData.printUrl, '_blank', 'toolbar=yes, width=800, height=600')
              } else {
                window.open(oriPriLabelUrl, '_blank', 'toolbar=yes, width=800, height=600')
              }
            } else {
              this.$customMessage.warning(jsonData.msg);
            }
          } catch (err) {
            that.pubPdfUploadOk(res)
          }
        };
        fileReader.readAsText(data)
      },
      showUrl() {
        if (this.noOfDestinationLabel >= 1) {
          let params = new FormData();
          params.append("orderNo", this.orderNo);
          params.append("noOfDestinationLabel", this.noOfDestinationLabel);
          axios.post(ajax.ajaxUrl() + api.CFSPRINTPARCELNO, params,{responseType:"blob"})
                  .then(res => {
                    this.pubPdfMsgfn(res, this.printLabelUrl);
          })
        } else {
          window.open(this.printLabelUrl, '_blank', 'toolbar=yes, width=800, height=600')
        }
      },
      showDhlInvoice() {
        window.open(this.showDhlInvoiceUrl, '_blank', 'toolbar=yes, width=800, height=600')
      },
      //            回退扫码数量
      DeleteChangeEvnt() {
        this.DeleteChecked = !this.DeleteChecked;
        this.lockChecked = true
        this.OtySaoNum = 1
      },
      //            表格样式
      cellClassName({
        row
      }) {
        if (row === this.selectRow) {
          return "col-orange";
        }
      },
      rowStyle({
        row
      }) {
        if (row.sscc == '*') {
          return {
            color: 'red'
          }
        }
      },
    }
  };
</script>
<style lang="less">
  .ant-btn-group>.ant-btn:first-child:not(:last-child),
  .ant-btn-group>span:first-child:not(:last-child)>.ant-btn {
    border: 0px;
  }

  .ant-dropdown-button>.ant-btn-default {
    padding: 0 7px;
    font-size: 14px;
    border-radius: 4px;
    height: 24px;
  }

  .ant-advanced-search-form .ant-form-item {
    display: flex;
  }

  .ant-advanced-search-form .ant-form-item-control-wrapper {
    flex: 1;
  }

  #components-form-demo-advanced-search .ant-form {
    max-width: none;
  }

  #components-form-demo-advanced-search .search-result-list {
    margin-top: 16px;
    border: 1px dashed #e9e9e9;
    border-radius: 6px;
    background-color: #fafafa;
    min-height: 200px;
    text-align: center;
    padding-top: 80px;
  }

  .scanCodeTile {
    font-size: 16px;
    text-align: center;
  }

  .radius {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 330px;
    height: 330px;
    border-radius: 50%;

    i {
      color: #fff;
    }
  }

  .scanpackHeader {
    display: flex;
    align-items: center;
    justify-content: left;
  }

  .scanpackTitle {
    font-size: 12px;
    margin: 0 10px;
    width: 120px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: right;
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
  }

  .slide-fade-enter-active {
    transition: all 0.1s ease;
  }

  .slide-fade-leave-active {
    transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
  }

  .slide-fade-enter,
  .slide-fade-leave-to

  /* .slide-fade-leave-active for below version 2.1.8 */
    {
    transform: translateX(10px);
    opacity: 0;
  }

  .mytable-style .vxe-body--row.row-green {
    background-color: darkseagreen;
    color: #333;
  }

  .existDataStyle {
    width: 80%;
    height: 120px;
    margin-top: 5px;
    padding-top: 40px;
    text-align: center;
    color: white;
    font-size: 100px;
  }

  .noDataStyle {
    width: 80%;
    height: 120px;
    margin-top: 5px;
    padding-top: 40px;
  }
</style>